import React, { useEffect, useState } from "react";
import * as HAN from '../style/StyleComponentHeaderAndNav';
import { useLocation, useNavigate } from "react-router-dom";
import { get_session, get_customer_summary, logout_request, get_customer_point, API_URL } from "../Axios";
import { Customer } from "../model/customer";
import { useDispatch } from "react-redux";
import { reduxChangeAccountID, reduxChangeAccountName, reduxChangeCancelReservation, reduxChangeCustomerAblackRate, reduxChangeCustomerID, reduxChangeCustomerMatching, reduxChangeCustomerName, reduxChangeCustomerPaymentReady, reduxChangeCustomerPaymentSuccess, reduxChangeCustomerPhoneNumber, reduxChangeCustomerPoint, reduxChangeCustomerSuccess, reduxChangeTotalReservation } from "../redux/CustomerSlice";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";
import { reduxResetCommunity } from "../redux/CommunitySlice";
import { commaPrice } from "../Validation";
import { PROCESS_MANUAL_URL } from "../Variable";

type Props = {
    offNavModal : () => void;
};

let data:Customer = {
    account_ID                : '',
    customer_ID               : 0,
    customer_ablack_rate      : 0,
    customer_email            : '',
    customer_ablack_rate_name : '',
    customer_name             : '',
    customer_phone_number     : '',
    customer_point            : ''
};

const Nav: React.FC<Props> = ({offNavModal}) => {
    const navigate = useNavigate();
    const customerData = useSelector((state: RootState) => state.customerData);
    const dispatch = useDispatch();
    const [customer, setCustomer] = useState<Customer>(data);
    const [positionY, setPositionY] = useState<number>(0);

    const locationHook = useLocation();
    const [currentLastUrl, setCurrentLastUrl] = useState<string | null>('');
    const updateNavSwitch = window.localStorage.getItem('update_nav_switch');

    useEffect(() => {
        const splitUrl = locationHook?.pathname?.split('/') ?? null;
        const location: string | null = splitUrl?.length > 1 ? splitUrl[splitUrl.length -1] : null;
        setCurrentLastUrl(location);
    }, [currentLastUrl, locationHook]);

    // FIXME: 여기도 나중에 obj 형식으로 리팩토링
    useEffect(() => {
        if (!currentLastUrl) return;
        if (
            currentLastUrl === 'privacy_policy_no_session' ||
            currentLastUrl === 'terms_of_service_no_session'
        ) return;
        get_session().then(result => {
            if(result.length === 0) {
                alert('세션이 만료되어 로그인페이지로 이동합니다.');
                navigate('/login');
            } else {
                setCustomer(result);
                dispatch(reduxChangeAccountName(result.account_name));
                dispatch(reduxChangeAccountID(result.account_ID));
                dispatch(reduxChangeCustomerID(result.customer_ID));
                dispatch(reduxChangeCustomerAblackRate(result.customer_ablack_rate));
                dispatch(reduxChangeCustomerName(result.customer_name));
                dispatch(reduxChangeCustomerPhoneNumber(result.customer_phone_number));
                // dispatch(reduxChangeCustomerPoint(result.customer_point));
            }
        });
    }, [currentLastUrl, dispatch, navigate]);

    useEffect(() => {
        if(customer.customer_ID) {
            get_customer_summary(customer.customer_ID.toString()).then(result => {
                dispatch(reduxChangeCustomerMatching(result[0].one_1_sum));
                dispatch(reduxChangeCustomerPaymentReady(result[0].one_2_sum));
                dispatch(reduxChangeCustomerPaymentSuccess(result[0].one_3_sum));
                dispatch(reduxChangeCustomerSuccess(result[0].one_4_sum));
                dispatch(reduxChangeCancelReservation(result[0].one_5_sum));
                dispatch(reduxChangeTotalReservation(result[0].one_total_sum));
            });
            get_customer_point(customer.customer_ID.toString()).then(result => {
                dispatch(reduxChangeCustomerPoint(result.customer_point));
            });
        }
    }, [customer, dispatch, updateNavSwitch]);

    // 스크롤 감지 이벤트
    useEffect(() => {
        const getScrollY = () => {
            let value = window.scrollY;
            setPositionY(value);
        };
        window.addEventListener('scroll', getScrollY);
        
        return () => {
            window.removeEventListener('scroll', getScrollY);
        };
    });
    
    const handleLink = (url:string) => {
        navigate(url);
        offNavModal();
        window.scrollTo(0, 0);
    };

    const handleDownload = () => {
        const url = PROCESS_MANUAL_URL;
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
          newWindow.focus();
        }
    };

    return (
        <div>
            <HAN.NavigationArea $positionY={positionY}>
                
                <HAN.CustomerInfoBox>
                    <div className="customer-account-box">
                        <div className="account">
                            <span className="customer-name">{customer.customer_name}</span>
                            <span className="nim">님</span>
                            <p>{customer.customer_email}</p>
                        </div>
                        <div>
                            <button
                                className="logout-btn"
                                onClick={() => {
                                    if(!window.confirm('로그아웃 하시겠습니까?')) return;
                                    logout_request().then(result => {
                                        alert('로그아웃 되었습니다.');
                                        navigate('/login');
                                    });
                                }}
                            >
                                로그아웃
                            </button>
                        </div>
                    </div>
                    <div className="customer-point-box">
                        <div>
                            <span className="customer-point-name">등급</span>
                            <span className="customer-point-value">{customer.customer_ablack_rate_name}</span>
                        </div>
                        <div className="cursor-pointer" onClick={() => handleLink('/point_detail')}>
                            <span className="customer-point-name">AP포인트</span>
                            <span className="customer-point-value">{commaPrice(Number(customerData.customer_point))} AP</span>
                        </div>
                    </div>
                </HAN.CustomerInfoBox>
                <HAN.UsageSummary $width={360} onClick={() => handleLink('/reservation_detail')}>
                    <div className="usage-items">
                        <p>매칭 중</p>
                        <span>{customerData.matching}</span>
                    </div>
                    <div className="usage-items">
                        <p>결제대기</p>
                        <span>{customerData.payment_ready}</span>
                    </div>
                    <div className="usage-items">
                        <p>결제완료</p>
                        <span>{customerData.payment_success}</span>
                    </div>
                    <div className="usage-items">
                        <p>시공완료</p>
                        <span>{customerData.construction_complete}</span>
                    </div>
                </HAN.UsageSummary>
                <HAN.HorizontalBar />
                <HAN.NavLinkBox>
                    <div>
                        <button onClick={handleDownload}>시공 프로세스 메뉴얼</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/estimate')}>견적 계산기</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/shopping_bag')}>견적 장바구니</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/reservation')}>A.Black 서비스 예약</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/reservation_detail')}>A.Black 서비스 이용 내역</button>
                    </div>
                </HAN.NavLinkBox>
                <HAN.NavLinkBox>
                    <div>
                        <button onClick={() => handleLink('/point_charge')}>AP포인트 충전</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/point_detail')}>AP포인트 내역</button>
                    </div>
                </HAN.NavLinkBox>
                <HAN.NavLinkBox>
                    <div>
                        <button
                            onClick={() => {
                                dispatch(reduxResetCommunity());
                                handleLink('/community');
                            }}
                        >
                            시공 포트폴리오
                        </button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/community_detail')}>시공 포트폴리오 작성 내역</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/community_favorite')}>시공 포트폴리오 즐겨찾기</button>
                    </div>
                </HAN.NavLinkBox>
                <HAN.NavLinkBox>
                    <div>
                        <button onClick={() => handleLink('/notice')}>공지사항</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/faq')}>FAQ</button>
                    </div>
                    <div>
                        <button onClick={() => handleLink('/qna')}>1:1 문의</button>
                    </div>
                </HAN.NavLinkBox>

            </HAN.NavigationArea>
        </div>
    )
};

export default Nav;